import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
} from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CoreModule } from '@rd/core/core.module';
import { DialogRef } from '@rd/popup/dialog-ref';
import { IconModule } from '@rd/shared-legacy/components/icon/icon.module';
import {
  BNZ_BANKWIDE_LOGIN_COPY_UPDATE,
  BNZ_BANKWIDE_UPDATES_ENABLED,
} from '../../tokens/features.tokens';

@Component({
  selector: 'bnz-auth-secure-route-dialog',
  template: `
    <div class="content p-5 lg:p-5">
      <div
        [ngClass]="{
          'close-button-container absolute': true,
          'right-5': isBnzBankwideUpdatesEnabled
        }">
        <button
          type="button"
          class="close-button button-reset focus-link h-4 w-4"
          [attr.aria-label]="'core.auth_dialog.close' | translate"
          (click)="closeDialog()">
          <rd-shared-icon [iconSymbol]="'icon-close'"></rd-shared-icon>
        </button>
      </div>

      <h1
        class="login-header typo-emphasis-2-mobile lg:typo-emphasis-2-desktop mb-4 mt-5 text-center">
        {{ 'core.auth_dialog.login_header' | translate }}
      </h1>
      <p
        class="login-description typo-text-mobile lg:typo-text-desktop my-0 text-center"
        [innerHTML]="descriptionText | translate"></p>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, CoreModule, IconModule, TranslateModule],
})
export class BnzAuthSecureRouteDialogComponent {
  @HostBinding('class.bnz-auth-secure-route-dialog') componentClass = true;

  dialogRef = inject(DialogRef);
  isBnzBankwideUpdatesEnabled = inject(BNZ_BANKWIDE_UPDATES_ENABLED);
  isBnzBankwideLoginCopyUpdate = inject(BNZ_BANKWIDE_LOGIN_COPY_UPDATE);

  closeDialog(): void {
    this.dialogRef.close();
  }

  get descriptionText(): string {
    return this.isBnzBankwideUpdatesEnabled && this.isBnzBankwideLoginCopyUpdate
      ? 'core.auth_dialog.login_description.update'
      : 'core.auth_dialog.login_description';
  }
}
